import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  serviceItemList: [],
  transferOrderList: [],
  technicianList: [],
  technicianInventory: [],
  technicianInventoryHistory: [],
  nonSaleApprovalList: [],
  isLoading: true,
};
const serviceSlice = createSlice({
    name: 'service',
    initialState,
    reducers: {
        setServiceItemList: (state, action) => {
            state.serviceItemList = action.payload;
            state.isLoading = false;
        },
        setTransferOrderList: (state, action) => {
            state.transferOrderList = action.payload;
            state.isLoading = false;
        },
        setTechnicianList: (state, action) => {
            state.technicianList = action.payload;
            state.isLoading = false;
        },
        setTechnicianInventory: (state, action) => {
            state.technicianInventory = action.payload;
            state.isLoading = false;
        },
        setTechnicianInventoryHistory: (state, action) => {
            state.technicianInventoryHistory = action.payload;
            state.isLoading = false;
        },
        setNonSaleApprovalList: (state, action) => {
            state.nonSaleApprovalList = action.payload;
            state.isLoading = false;
        },
    },
});

export const { setServiceItemList, setTransferOrderList, setTechnicianList, setTechnicianInventory, setTechnicianInventoryHistory, setNonSaleApprovalList } = serviceSlice.actions;
const serviceReducer = serviceSlice.reducer;
export default serviceReducer;
